module.exports = __webpack_public_path__ + "./img/mobile.9fc6eb1c4de08e0eca56242af5ac308e.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/mockups/mobile.jpg
// module id = ./public/img/mockups/mobile.jpg
// module chunks = 0